<template>
    <div class="main hsmy">
        <Banner :banner="banner"/>
        <Headlines :headlines="headlines"/>

        <div class="content-box">
            <div class="left-box">
                <Article :article="review"/>
                <Article :article="comment"/>
                <Project :project="project"/>
            </div>

            <Rightbox/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'hsmy',
    // meta配置
    metaInfo: {
        title: '【专题】' + '还想浑水摸鱼？国家出《禁止网络不正当竞争行为规定》征求意见！',
        meta: [
            {
                name: 'keywords',
                content: '浑水摸鱼 市场监管总局 国家 不正当竞争 快评 法律'
            },
            {
                name: 'description',
                content: '8月17日，市场监管总局就《禁止网络不正当竞争行为规定(公开征求意见稿 )》公开征求意见。“二选一”、数据“杀熟”、网络虚假宣传、虚假交易等网络领域不正当竞争行为将面临更严格、更细致的监管。'
            }
        ]
    },
    data() {
        return {
            // 头图标题
            banner: {
                img: require('@/assets/hsmy/banner.jpg'),
                title: [
                    '还想浑水摸鱼？国家出《禁止网络不正当竞争行为规定》征求意见！',
                    '',
                ],
                text: '8月17日，市场监管总局就《禁止网络不正当竞争行为规定(公开征求意见稿 )》公开征求意见。“二选一”、数据“杀熟”、网络虚假宣传、虚假交易等网络领域不正当竞争行为将面临更严格、更细致的监管。'
            },

            // 最新动态
            review: {
                title: {
                    topic: '最新动态',
                    more: {
                        name: '我要投诉>',
                        url: '/Index/complain.html'
                    }
                },
                list: [
                    {
                        id: '6599499',
                        title: '市监总局就《禁止网络不正当竞争行为规定》公开征求意见',
                        post_date: '2021-08-18 08:58:16'
                    },
                    {
                        id: '6599536',
                        title: '“二选一”大数据“杀熟”等将面临更严格监管',
                        post_date: '2021-08-18 10:46:14'
                    },
                    {
                        id: '6599457',
                        title: '《禁止网络不正当竞争行为规定》征求意见出炉',
                        post_date: '2021-08-17 10:32:14'
                    },
                    {
                        id: '6599444',
                        title: '绝不纵容！立法拟对APP收集个人信息等作出规范',
                        post_date: '2021-08-17 09:41:22'
                    },
                    {
                        id: '6598444',
                        title: '国家网信办明确 仅39类为必要个人信息',
                        post_date: '2021-07-23 10:46:05'
                    },
                ],
            },

            // 网经社快评
            comment: {
                title: {
                    topic: '网经社快评',
                },
                list: [
                    {
                        id: '6596865',
                        title: '【电商快评】国家重磅出手严打 大数据“杀熟”或成历史',
                        post_date: '2021-07-05 18:50:57'
                    },
                    {
                        id: '6589850',
                        title: '【电商快评】美团 饿了么因不正当竞争双双被判向对方支付赔偿',
                        post_date: '2021-04-16 08:48:27'
                    },
                    {
                        id: '6582713',
                        title: '【电商快评】因涉嫌不正当竞争唯品会被立案调查释放那些信号？',
                        post_date: '2021-01-14 14:54:18'
                    },
                    {
                        id: '6581599',
                        title: '【电商快评】网经社：美团取消支付宝支付是否存在不正当竞争行为？',
                        post_date: '2020-12-30 10:56:54'
                    },
                    {
                        id: '6442523',
                        title: '【电商快评】大数据成双刃剑 杀熟是否涉嫌违法有待争议',
                        post_date: '2018-03-27 14:56:22'
                    },
                ],
            },

            // 相关专题
            project: {
                title: {
                    topic: '相关专题',
                },
                list: [
                    {
                        body: '/zt/yhxx/',
                        image: '/zt/upload_data/yhxx/images/550.jpg'
                    },
                    {
                        body: '/zt/aqsc/',
                        image: '/zt/upload_data/aqsc/images/550.jpg'
                    },
                    {
                        body: '/zt/wphjg/',
                        image: '/zt/upload_data/wphjg/images/550.jpg'
                    },
                    {
                        body: '/zt/mtelm_exy/',
                        image: '/Public/attached/2020/04/03/5e868bd934d09.jpg'
                    },
                ]
            }
        }
    },
}
</script>

<style>

@media(max-width：1200px) {
    .hsmy .banner-title span {
        font-size: 50px;
        word-wrap: break-word;
    }
}


</style>
